<!-- Small/Medium viewport -->
<div class="d-block d-lg-none mb-3" *ngFor="let document of request.documentInfo; int let i = index;">
    <app-reviewandsenddocumentslistitem [document]="document" [documentIndex]="i+1" [actors]="request.actors" (openPreview)="openPreview($event)"></app-reviewandsenddocumentslistitem>
</div>

<!-- Large viewport -->
<ul class="d-none d-lg-block list-group p-1">
    <li class="list-group-item subheader d-block pt-1 pe-0 pb-1 ps-2">
        <div class="row w-100 d-flex p-0 align-items-center">
            <div class="col-4 firstcol text-truncate" translate>Request.ReviewSend.DocumentName</div>
            <div class="col-4 text-truncate" translate>Request.ReviewSend.DocumentID</div>
            <div class="col-2 text-truncate" translate>Request.ReviewSend.DocumentType</div>
            <div class="col-1 text-truncate" translate>Request.ReviewSend.Filesize</div>
            <div class="col-1 text-truncate"></div>
        </div>
    </li>
    <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2" *ngFor="let document of request.documentInfo; int let i = index;">
        <app-reviewandsenddocumentslistitem [document]="document" [documentIndex]="i+1" [actors]="request.actors" (openPreview)="openPreview($event)"></app-reviewandsenddocumentslistitem>
    </li>
</ul>